export class EndpointsReply {
    entityId: string;
    metadataUrl: string;
    loginUrl: string;
    acsUrl: string;

    constructor() {
        this.entityId = '';
        this.metadataUrl = '';
        this.loginUrl = '';
        this.acsUrl = '';
    }
}